module.exports = __webpack_public_path__ + "static/img/052.c3bf5a0.png";


//////////////////
// WEBPACK FOOTER
// ./static/smPicImgs/052.png
// module id = ELip
// module chunks = 0